(function() {

    var sectionEl = document.querySelector('.rvp-section');

    function showSection(){ sectionEl && sectionEl.classList.remove('is-hidden'); }
    function hideSection(){ sectionEl && sectionEl.classList.add('is-hidden'); }

    var KEY = 'rv_handles';
    var grid = document.querySelector('.rvp-grid[data-section-id]');
    if (!grid) return;

    var limit = parseInt(grid.getAttribute('data-limit') || '6', 10);
    var currentHandle = grid.getAttribute('data-current-handle') || '';

    var rvpLocale = window.rvpLocale || 'en';
    var rvpColorMap = window.rvpColorMap || {};
    var rvpColorPatterns = window.rvpColorPatterns || {};

    function escapeHtml(str) {
        return String(str || '')
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#39;');
    }

    function handleize(str) {
        return String(str || '')
            .toLowerCase()
            .trim()
            .replace(/['"]/g, '')
            .replace(/[\s\/\\]+/g, '-')
            .replace(/-+/g, '-');
    }

    function getDynamicColorData(val) {
        var originalValue = String(val || '').trim();
        var colorHandle = handleize(originalValue);
        var displayName = originalValue;
        var hexCode = '';

        if (rvpLocale !== 'en' && rvpColorMap && rvpColorMap[originalValue]) {
            if (rvpColorMap[originalValue].handle) {
                colorHandle = rvpColorMap[originalValue].handle;
            }
            if (rvpColorMap[originalValue].color_name) {
                displayName = rvpColorMap[originalValue].color_name;
            }
        }

        if (rvpColorPatterns && rvpColorPatterns[colorHandle] && rvpColorPatterns[colorHandle].hex) {
            hexCode = rvpColorPatterns[colorHandle].hex;
        }

        return {
            original_value: originalValue,
            color_handle: colorHandle,
            display_name: displayName,
            hex_code: hexCode
        };
    }

    grid.addEventListener('click', function (e) {
        var label = e.target.closest('.swatch-label');
        if (!label || !grid.contains(label)) return;

        var image = label.getAttribute('data-img');
        var price = label.getAttribute('data-price');
        var productId = label.getAttribute('data-product-id');

        var card = label.closest('.product');
        if (card) {
            var imgInCard = card.querySelector('.wishlist-img-' + productId);
            if (imgInCard && image) imgInCard.src = image;

            card.querySelectorAll('.price-wishlist-p-' + productId).forEach(function(node){
                node.textContent = price;
            });
        }

        document.querySelectorAll('.wishlist-img-' + productId).forEach(function(img){
            if (image) img.src = image;
        });

        document.querySelectorAll('.price-wishlist-p-' + productId).forEach(function(node){
            node.textContent = price;
        });

        var list = label.closest('.swatch');
        if (list) {
            list.querySelectorAll('.swatch-label.is-active').forEach(function(el){
                el.classList.remove('is-active');
            });
        }
        label.classList.add('is-active');
    });

    function hasSellableVariant(p) {
        if (!p || !Array.isArray(p.variants)) return false;
        return p.variants.some(function(v){
            var price = parseFloat(v && v.price);
            return v && v.available === true && Number.isFinite(price) && price > 0;
        });
    }

    function isDisplayable(p) {
        if (!p) return false;
        if (p.type === 'Warranty' || p.type === 'Battery') return false;
        if (p.available !== true) return false;
        if (!hasSellableVariant(p)) return false;
        return true;
    }

    function normalizeTitle(t) {
        return String(t || '')
            .toLowerCase()
            .replace(/\s+/g, ' ')
            .trim();
    }

    function uniqByHandleAndTitle(products) {
        var seenHandles = new Set();
        var seenTitles  = new Set();

        return (products || []).filter(function (p) {
            if (!p) return false;

            var h = p.handle || '';
            var t = normalizeTitle(p.title);

            if (h && seenHandles.has(h)) return false;
            if (t && seenTitles.has(t)) return false;

            if (h) seenHandles.add(h);
            if (t) seenTitles.add(t);
            return true;
        });
    }

    // Drop a stored handle that no longer exists (e.g. product deleted or its URL handle changed)
    function removeStoredHandle(handle) {
        try {
            var list = JSON.parse(localStorage.getItem(KEY) || '[]');
            if (!Array.isArray(list) || list.indexOf(handle) === -1) return;
            localStorage.setItem(KEY, JSON.stringify(list.filter(function(h){ return h !== handle; })));
        } catch (e) {}
    }

    function fetchProduct(handle, forDisplayOnly) {
        const root = getLangRoot();

        return fetch(root + '/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
            .then(function(r){
                if (r.status === 404) removeStoredHandle(handle);
                if (!r.ok) throw new Error('HTTP ' + r.status);
                return r.json();
            })
            .then(function(p){
                p.url = root + '/products/' + p.handle;
                if (forDisplayOnly && !isDisplayable(p)) return null;
                return p;
            })
            .catch(function(){
                return null;
            });
    }

    function createProductHTML(product) {
        if (!product || !product.variants || !product.available || product.type == "Warranty" || product.type == "Battery") return '';

        var lease_price = (product.variants || []).reduce(function(least, current) {
            var currentPrice = parseFloat(current.price);
            if (!Number.isFinite(currentPrice) || currentPrice <= 0) return least;
            if (!least || currentPrice < parseFloat(least.price)) return current;
            return least;
        }, null) || (product.variants && product.variants[0]) || null;

        if (!lease_price) return '';

        var price_min = Shopify.formatMoney(lease_price.price, window.money_format);
        var compare_at = Shopify.formatMoney(lease_price.compare_at_price, window.money_format);

        var percentageHTML = '';
        var cp = parseFloat(lease_price.compare_at_price);
        var pr = parseFloat(lease_price.price);

        // TH store does not sell Smartphones: show sold out instead of the discount badge
        var isThSoldOut = typeof global_store !== 'undefined' && global_store === 'th' &&
            String(product.type || '').toLowerCase().indexOf('smartphone') !== -1;

        if (isThSoldOut) {
            percentageHTML =
                '<div class="card__badge bdgeProduct' + product.id + ' badge-left halo-productBadges halo-productBadges--left th-sold-out">' +
                    '<span class="badge sold-out-badge sold-out-badge--th" aria-hidden="true">' + (window.rvpSoldOutText || 'Sold out') + '</span>' +
                '</div>';
        } else if (Number.isFinite(cp) && Number.isFinite(pr) && cp > pr && cp > 0) {
            var percentage = (pr / cp) * 100;
            var integerPercentage = Math.floor(100 - percentage);

            if (document.documentElement.lang === 'ar') {
                percentageHTML =
                    '<div class="card__badge bdgeProduct' + product.id + ' badge-left halo-productBadges halo-productBadges--left">' +
                        '<span class="badge sale-badge" aria-hidden="true">' +
                        '<span class="vs-badge">مقارنة بالجديد</span> <span class="percentagebdg">-' + integerPercentage + '%</span>' +
                        '</span>' +
                    '</div>';
            } else {
                percentageHTML =
                    '<div class="card__badge bdgeProduct' + product.id + ' badge-left halo-productBadges halo-productBadges--left">' +
                        '<span class="badge sale-badge" aria-hidden="true"> -' + integerPercentage + '% ' + global_vs_new + ' </span>' +
                    '</div>';
            }
        }

        var maxVisibleSwatches = 4;
        var groupedVariants = (product.variants || []).reduce(function(groups, variant) {
            if (!variant || !variant.option1) return groups;
            var p = parseFloat(variant.price);
            if (!Number.isFinite(p) || p <= 0) return groups;
            (groups[variant.option1] = groups[variant.option1] || []).push(variant);
            return groups;
        }, {});

        var groupedKeys = Object.keys(groupedVariants);

        groupedKeys.sort(function(a, b) {
            var priceA = parseFloat(groupedVariants[a][0].price);
            var priceB = parseFloat(groupedVariants[b][0].price);
            return priceA - priceB;
        });

        var firstVariant = groupedKeys.length ? (groupedVariants[groupedKeys[0]][0] || {}) : {};
        var variantImg = firstVariant.featured_image && (firstVariant.featured_image.src || firstVariant.featured_image);
        var productImg = (product.images && product.images[0] && product.images[0].src) || product.featured_image || '';
        var featuredImageSrc = variantImg || productImg || '';
        var featuredAlt = (product.featured_image && product.featured_image.alt) || product.title || '';

        var swatchesHTML = groupedKeys.slice(0, maxVisibleSwatches).map(function(groupKey, index) {
            var variant = groupedVariants[groupKey][0];
            var featuredImage = (variant.featured_image && (variant.featured_image.src || variant.featured_image)) || productImg;
            var variantPrice = Shopify.formatMoney(variant.price, window.money_format);
            var activeClass = index === 0 ? 'is-active' : '';

            var colorData = getDynamicColorData(groupKey);
            var bgStyle = colorData.hex_code ? colorData.hex_code : 'transparent';

            return ''
                + '<li class="item">'
                + '  <div class="item-wrapper clearfix">'
                + '    <label class="swatch-label ' + activeClass + '"'
                + '      data-value="' + escapeHtml(handleize(colorData.display_name)) + '"'
                + '      title="' + escapeHtml(groupKey) + '"'
                + '      data-img="' + escapeHtml(featuredImage) + '"'
                + '      data-price="' + escapeHtml(variantPrice) + '"'
                + '      data-product-id="' + product.id + '">'
                + '      <span class="pattern" style="background-color: ' + escapeHtml(bgStyle) + ';"></span> ' + escapeHtml(colorData.display_name)
                + '    </label>'
                + '    <span class="tooltip">' + escapeHtml(groupKey) + '</span>'
                + '  </div>'
                + '</li>';
        }).join('');

        var totalColors = 0;
        (product.options || []).forEach(function(option) {
            if (option && option.name === 'Color') totalColors = option.values.length;
        });

        var additionalSwatches = totalColors - maxVisibleSwatches;
        if (additionalSwatches > 0) {
            swatchesHTML += ''
                + '<li class="item more-swatches">'
                + '  <span class="more-count">+' + additionalSwatches + '</span>'
                + '</li>';
        }

        var hasColorOption = (product.options || []).some(function(option){
            return option && option.name === 'Color';
        });

        var productMeta = hasColorOption
            ? '<div class="card-swatch text-center clearfix" id="product-swatch-' + product.id + '"><ul class="swatch list-unstyled">' + swatchesHTML + '</ul></div>'
            : '';

        return ''
            + '<div class="product p_v_' + product.id + '" data-p-title="' + escapeHtml(product.title) + '" data-p-price="' + lease_price.price + '">'
            + '  <div class="product-item" data-product-id="' + product.id + '">'
            + '    <div class="card ajax-loaded">'
            + '      <div class="card-product">'
            + '        <div class="card-product__wrapper">'
            +            percentageHTML
            + '          <a class="card-media card-media--square" href="' + escapeHtml(product.url) + '" style="padding-bottom: 100%;">'
            + '            <img src="' + escapeHtml(featuredImageSrc) + '" alt="' + escapeHtml(featuredAlt) + '" class="wishlist-img-' + product.id + '" loading="lazy">'
            + '            <span class="data-lazy-loading"></span>'
            + '          </a>'
            + '          <div class="card-product__group-item card-wishlist">'
            + '              <a class="wishlist-icon" href="#." data-wishlist="" data-wishlist-handle="' + escapeHtml(product.handle) + '" data-product-title="' + escapeHtml(product.title) + '" data-product-id="' + product.id + '" onclick="showWishlistPopup(this)" data-tracking-section="recently-view-product-home-page" data-tracking-value="' + escapeHtml(product.title) + '" tabindex="0">'
            + '                  <img src="https://cdn.shopify.com/s/files/1/0695/1737/7855/files/wish_unslected.svg?v=1736520059" class="unselected-wishlist-icon">'
            + '                  <img src="https://cdn.shopify.com/s/files/1/0695/1737/7855/files/wish_selected.svg?v=1736520059" class="selected-wishlist-icon">'
            + '              </a>'
            + '          </div>'
            + '          <div class="card-product__group group-right"></div>'
            + '        </div>'
            + '      </div>'
            + '      <div class="card-information">'
            + '        <div class="card-information__wrapper text-center">'
            + '          <a class="card-title link-underline card-title-ellipsis card-title-change" href="' + escapeHtml(product.url) + '" data-product-title="' + escapeHtml(product.title) + '" data-product-url="' + escapeHtml(product.url) + '">'
            + '            <h2 class="text">' + escapeHtml(product.title) + '</h2>'
            + '          </a>'
            + '          <div class="card-summary card-list__hidden C"></div>'
            +             productMeta
            + '          <div class="card-price">'
            + '            <div class="price price--on-sale">'
            + '              <dl>'
            + '                <div class="price__regular">'
            + '                  <dd class="price__last">'
            + '                    <span class="price-item price-item--regular price-wishlist-p-' + product.id + '">' + price_min + '</span>'
            + '                  </dd>'
            + '                </div>'
            + '                <div class="price__sale">'
            + '                  <dd class="price__last" style="padding-top: 4px;">'
            + '                    <span class="price-item price-item--sale price-wishlist-p-' + product.id + '">' + price_min + '</span>'
            + '                  </dd>'
            + '                  <dd class="price__compare">'
            + '                    <s class="price-item price-item--regular">' + compare_at + '</s>'
            + '                    <span class="product-condition">' + escapeHtml(product.condition || '') + '</span>'
            + '                  </dd>'
            + '                </div>'
            + '              </dl>'
            + '            </div>'
            + '          </div>'
            + '        </div>'
            + '      </div>'
            + '    </div>'
            + '  </div>'
            + '</div>';
    }

    function initSlickOnGrid() {
        if (!window.jQuery || !jQuery.fn || !jQuery.fn.slick) {
            console.warn('[RecentlyViewed] Slick not found. Load slick before this section.');
            return;
        }

        var $grid = jQuery(grid);

        if ($grid.hasClass('slick-initialized')) {
            $grid.slick('unslick');
        }

        var isRTL = document.documentElement.getAttribute('dir') === 'rtl';

        $grid.slick({
            infinite: true,
            arrows: true,
            dots: false,
            slidesToShow: 5,
            slidesToScroll: 5,
            rtl: isRTL,
            responsive: [
                { breakpoint: 1171, settings: { slidesToShow: 4, slidesToScroll: 4 } },
                { breakpoint: 769, settings: { slidesToShow: 3, slidesToScroll: 3 } },
                { breakpoint: 701, settings: { slidesToShow: 2, slidesToScroll: 1 } },
                { breakpoint: 601, settings: { slidesToShow: 1, slidesToScroll: 1 } }
            ]
        });
    }

    function render(products) {
        var clean = (products || []).filter(Boolean);

        if (!clean.length) {
            hideSection();
            if (window.jQuery && jQuery.fn && jQuery.fn.slick && jQuery(grid).hasClass('slick-initialized')) {
                jQuery(grid).slick('unslick');
            }
            grid.innerHTML = '';
            return;
        }

        grid.innerHTML = clean.map(createProductHTML).join('');
        showSection();
        initSlickOnGrid();
    }

    function getLangRoot() {
        let root = (window.Shopify && Shopify.routes && Shopify.routes.root_url) ? Shopify.routes.root_url : '';

        if (root === '/' || root === '') {
            const pathParts = window.location.pathname.split('/');
            if (pathParts[1] && pathParts[1].match(/^[a-z]{2}(-[a-z]{2})?$/i)) {
                root = '/' + pathParts[1];
            }
        }

        if (root.endsWith('/')) root = root.slice(0, -1);

        return root === '/' ? '' : root;
    }

    function fetchRecommendationHandles(productId, limit) {
        var url = getLangRoot() + '/recommendations/products.json?product_id=' + encodeURIComponent(productId) +
            '&limit=' + (limit || 10) + '&intent=related';

        return fetch(url, { credentials: 'same-origin' })
            .then(function(r){
                if (!r.ok) throw new Error('HTTP ' + r.status);
                return r.json();
            })
            .then(function(json){
                return Array.isArray(json && json.products) ? json.products.map(function(p){ return p.handle; }) : [];
            })
            .catch(function(){
                return [];
            });
    }

    function pickEvenly(recHandleLists, seen, needed, currentHandle) {
        if (needed <= 0 || !recHandleLists.length) return [];

        var cleaned = recHandleLists.map(function(list){
            var uniq = [];
            var s = new Set();

            (list || []).forEach(function(h){
                if (!h || h === currentHandle || seen.has(h)) return;
                if (!s.has(h)) {
                    s.add(h);
                    uniq.push(h);
                }
            });

            return uniq;
        }).filter(function(arr){
            return arr.length;
        });

        var n = cleaned.length;
        if (!n) return [];

        var picks = [];
        var baseShare = Math.floor(needed / n);
        var remainder  = needed % n;

        for (var i = 0; i < n; i++) {
            var want = baseShare + (i < remainder ? 1 : 0);
            var got = Math.min(want, cleaned[i].length);

            for (var k = 0; k < got; k++) {
                picks.push(cleaned[i][k]);
                seen.add(cleaned[i][k]);
                if (picks.length === needed) return picks;
            }
        }

        var cursors = cleaned.map(function(arr, idx){
            return Math.min(arr.length, baseShare + (idx < remainder ? 1 : 0));
        });

        while (picks.length < needed) {
            var added = false;

            for (var j = 0; j < n && picks.length < needed; j++) {
                var idx = cursors[j];
                if (idx < cleaned[j].length) {
                    var h = cleaned[j][idx];
                    if (!seen.has(h) && h !== currentHandle) {
                        picks.push(h);
                        seen.add(h);
                        added = true;
                    }
                    cursors[j] = idx + 1;
                }
            }

            if (!added) break;
        }

        return picks;
    }

    (function init() {
        var TARGET = Math.max(10, limit);

        var handles = [];
        try {
            handles = JSON.parse(localStorage.getItem(KEY) || '[]');
        } catch (e) {}

        handles = handles.filter(function (h) {
            return h && h !== currentHandle;
        });

        if (!handles.length) {
            render([]);
            return;
        }

        Promise.all(handles.map(function (h) {
            return fetchProduct(h, false);
        }))
        .then(function (baseProducts) {
            baseProducts = (baseProducts || []).filter(Boolean);
            if (!baseProducts.length) {
                render([]);
                return;
            }

            return Promise.all(baseProducts.map(function (p) {
                return fetchRecommendationHandles(p.id, 10);
            }))
            .then(function (recLists) {
                var initialHandles = handles.slice(0, TARGET);
                var seen = new Set(initialHandles);
                seen.add(currentHandle);

                recLists = recLists
                    .map(function (list) {
                        var out = [], s = new Set();
                        (list || []).forEach(function (h) {
                            if (!h || seen.has(h)) return;
                            if (!s.has(h)) {
                                s.add(h);
                                out.push(h);
                            }
                        });
                        return out;
                    })
                    .filter(function (arr) {
                        return arr.length;
                    });

                return Promise.all(initialHandles.map(function (h) {
                    return fetchProduct(h, true);
                }))
                .then(function (initialProducts) {
                    var displayable = (initialProducts || []).filter(isDisplayable);
                    var remaining = TARGET - displayable.length;

                    if (remaining > 0) {
                        var fillerHandles = pickEvenly(recLists, seen, remaining, currentHandle);

                        return Promise.all(fillerHandles.map(function (h) {
                            return fetchProduct(h, true);
                        }))
                        .then(function (fillerProducts) {
                            var fillerDisplayable = (fillerProducts || []).filter(isDisplayable);

                            var stillShort = TARGET - (displayable.length + fillerDisplayable.length);
                            if (stillShort > 0) {
                                var extraHandles = pickEvenly(recLists, seen, stillShort, currentHandle);

                                return Promise.all(extraHandles.map(function (h) {
                                    return fetchProduct(h, true);
                                }))
                                .then(function (extraProducts) {
                                    var extraDisplayable = (extraProducts || []).filter(isDisplayable);
                                    var finalList = uniqByHandleAndTitle(displayable.concat(fillerDisplayable, extraDisplayable)).slice(0, TARGET);
                                    render(finalList);
                                });
                            }

                            var finalList = uniqByHandleAndTitle(displayable.concat(fillerDisplayable)).slice(0, TARGET);
                            render(finalList);
                        });
                    }

                    render(uniqByHandleAndTitle(displayable).slice(0, TARGET));
                });
            });
        })
        .catch(function () {
            render([]);
        });
    })();

})();